export default function Tag(props) {
  return (
    <div className="tag">
      {props.children}
    </div>
  );
}